export function useCameraPermission() {
  const hasPermission = true
  const requestPermission = () => {}
  return { hasPermission, requestPermission }
}
